import { mapActions } from 'vuex'
import { BUSINESS_FILES, IDENTITY_FILES } from '@/constants/store.js'

const getFileMixin = (loadingParamName) => {
  return {
    methods: {
      ...mapActions(BUSINESS_FILES.NAMESPACE, {
        downloadBusinessFileAction: BUSINESS_FILES.ACTIONS.DOWNLOAD_BUSINESS_FILE
      }),
      ...mapActions(IDENTITY_FILES.NAMESPACE, {
        downloadIdentityFileAction: IDENTITY_FILES.ACTIONS.DOWNLOAD_IDENTITY_FILE
      }),
      // ...mapActions(CERTIFICATES_MANAGEMENT.NAMESPACE, {
      //   getCertificateFileAction: CERTIFICATES_MANAGEMENT.ACTIONS.GET_CERTIFICATE_FILE
      // }),
      // скачать файл с сервера
      getBusinessFile: async function (fileId) {
        this[loadingParamName] = true
        await this.downloadBusinessFileAction({ fileId })
        this[loadingParamName] = false
      },
      getIdentityFile: async function (fileId) {
        this[loadingParamName] = true
        await this.downloadIdentityFileAction({ fileId })
        this[loadingParamName] = false
      }
      // getCertificateFile: async function (certificateId) {
      //   try {
      //     this[loadingParamName] = true
      //     await this.getCertificateFileAction({ certificateId })
      //   } catch (error) {
      //     this.throwIfUnknownError(error)
      //   } finally {
      //     this[loadingParamName] = false
      //   }
      // },
      // // сформировать файл подписи
      // getSignatureFile: function (signatureContent, fileName) {
      //   if (signatureContent) {
      //     Vue.helpers.downloadFile(signatureContent, fileName + '.sig', 'application/pgp-signature')
      //   }
      // }
    }
  }
}

export default getFileMixin
